import Task from '../../../lib/html5-software-library/src/ranj/util/executor/Task';
import { getURLParameter } from '../../../lib/html5-software-library/src/ranj/util/URLUtil';
import AppSignalService from './AppSignalService';
import CrashOnPurposeService from './CrashOnPurposeService';

export default class InitAppSignalTask extends Task {
    /**
     * @constructor
     * @param {AppSignalService} appSignalService 
     */
    constructor(appSignalService) {
        super();

        this._appSignalService = appSignalService;
    }

    execute(callback, progressCallback) {
        this._initAppSignal(callback);
    }

    _initAppSignal(callback) {
        this._appSignalService.connect()
            .then(() => {
                console.log(`InitAppSignalTask completed.`);

                if (getURLParameter('crashOnPurpose') == '1') {
                    CrashOnPurposeService.crashOnPurpose();
                }

                callback(this);
            });
    }
}